<template>
    <div id="nav-header-box" :class="{ clearfix: true, 'fixed-top': navIndex == 0 }">
        <nav class="navbar navbar-expand-lg navbar-light">
            <router-link :class="{ 'navbar-brand': true, }" to="/">
                <img :src="!topPic ? require('../../public/images/h3.jpg') : require('../../public/images/h3.jpg')"
                    class="d-inline-block align-top" alt="" loading="lazy">
            </router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul class="navbar-nav nav">
                    <li v-for="(item, key) in navData" :key="key"
                        :class="['nav-item', 'px-md-3', item.index == navIndex ? 'active' : '']">
                        <a class="nav-link"><router-link :to="item.path">{{ item.name }}</router-link>
                            <ul v-if="item.children" class="nav-children-box">
                                <li v-for="(value, index) in item.children" :key="index"
                                    @click="goChildren(item.path, value.query, $event)">{{ value.name }}</li>
                                <div class="nav-bg-box"></div>
                            </ul>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>

</template>
<script>
import { mapState } from 'vuex';

export default {
    name: "",
    data() {
        return {
            topPic: true,
            navData: [
                {
                    name: "首页",
                    path: "/",
                    index: 0,
                },
                {
                    name: "我们的酒庄",
                    path: "/winery",
                    index: 1,
                },
                {
                    name: "精选美酒",
                    path: "/wine",
                    index: 2,
                },
                {
                    name: "葡旅空间",
                    path: "/zoom",
                    index: 3,
                },
                {
                    name: "美酒生活",
                    path: "/life",
                    index: 4,
                },
                {
                    name: "联系我们",
                    path: "/contact",
                    index: 5,
                },
            ]
        }
    },
    computed: {
        ...mapState(['navIndex'])
    },
    methods: {
        /**
         * @desc 跳转路由
         */
        goChildren(path, query, event) {
            event.stopPropagation();
            this.$router.push({
                path,
                query
            })
        }
    },
    mounted() {
        window.addEventListener('scroll', (e) => {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            if (scrollTop > 500) {
                this.topPic = false;
            } else {
                this.topPic = true;
            }

        })
    }
}
</script>
<style lang="scss" scoped>
#nav-header-box {
    background: #6a0b2d;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;

    .fixed-top {
        position: fixed;
        top: 0;
        left: 0;
        padding: 0;
    }

    .navbar {
        padding: 0;
    }

    .nav {
        height: 100%;
        align-items: center;
        padding-right: 70px;

        .nav-link {
            padding: 0;
            position: relative;

            a {
                color: #fff;
                text-decoration: none;
            }

            .nav-children-box {
                height: 0;
                transition: height 0.5s linear;
                position: absolute;
                top: 60px;
                width: 100%;
                list-style: none;
                padding: 0px;
                color: #ccc;
                font-size: 14px;
                overflow: hidden;
                width: 120px;
                left: -35%;

                li {
                    height: 30px;
                    line-height: 30px;
                    width: 100%;
                    box-sizing: border-box;
                    margin-top: 10px;
                    cursor: pointer;

                    &:hover {
                        border: 1px solid #666666;
                    }
                }
            }

            .nav-bg-box {
                width: 100%;
                height: 0;
                background: rgba(0, 0, 0, 0.5);
                position: fixed;
                top: 80px;
                left: 0px;
                z-index: -10;
                transition: height 0.5s linear;
            }

            &:hover {
                border-bottom: 1px solid #fff;

                .nav-children-box {
                    height: 120px;
                }

                .nav-bg-box {
                    height: 150px;
                }
            }
        }

        .active {
            .nav-link {
                transition: all 0.4s;
                border-bottom: 1px solid #fff;

                a {
                    color: #fff;
                }
            }
        }

        .nav-phone-box {
            padding-left: 60px;
            background: url('../../public/images/phone.png') 30px center no-repeat;
            background-size: 19px 24px;
        }
    }
    .navbar-toggler {
        margin-right: 20px;
    }
    .navbar-brand {
        padding-left: 50px;

        img {
            max-width: 120px;
        }
    }

}
</style>